import React from 'react';

function About() {
    return (
        <section>
            <p>Learn more about Wildflower Arts Collective.</p>
        </section>
    );
}

export default About; 